import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'connectPremiumCard',
    'connectPremiumTab',
    'connectTab'
  ];

  hideContent() {
    if (this.hasConnectPremiumCardTarget) {
      this.connectPremiumCardTarget.classList.remove('d-none');
    }
  }

  showContent() {
    if (this.hasConnectPremiumCardTarget) {
      this.connectPremiumCardTarget.classList.add('d-none');
    }
  }
}
